import React, { Component } from 'react';
import { reduxForm, SubmissionError } from 'redux-form';
import StreamingValidator from '../../validators/StreamingValidator'
import InputField from '../Inputs/InputField'
import {sections} from '../../utils/variables'
class PageForm extends Component {

    constructor(props) {
	super(props);
	this.state = {
	    waiting: false
	}
    }
    
    
    componentDidMount(){


    }
    
    render() {
	const { handleSubmit, successAction } = this.props

	let {waiting} = this.state
	
	const submit = (values, dispatch, props) => {
	    let errors = StreamingValidator( values, props ) || {};
	    waiting=true
	    this.setState({waiting})
	    if (Object.keys(errors).length) {
		throw new SubmissionError(errors);
	    } else {

		let saveAction = values.id ? props.updateStreaming : props.saveStreaming
		
		saveAction(values).then((res) => {
		    props.reset()
		    successAction()
		    waiting=false
		    this.setState({waiting})
		}).catch((err) => {console.log(err)

		    waiting=false
		    this.setState({waiting})
		})
	    }
	}

	
	return (

	    <form onSubmit={handleSubmit(submit)}>
		<InputField name="title" type="text" label="Naslov" />
		<InputField name="stream_id" type="text" label="Id streaminga" />
		<InputField name="date_from" type="datetime" label="Zacetrk dogodka"  />
		<InputField name="date_to" type="datetime" label="Konec dogodka"  />

		<button type="submit" disabled={this.props.invalid || waiting} className="btn btn-brown btn-big full-width" >
		    <i style={{display: (waiting ? 'inline-block' : 'none' )}} className="fa fa-spinner fa-spin"></i>
		    {
			this.props.invalid ?
			'Pomankljivosti v unosu podtkov poglej zgoraj'
			:
			'Shrani'
		    }
		</button>
	    </form>
	);
    }
}

export default reduxForm({
    form: 'page',
    validate: StreamingValidator,
    enableReinitialize: true
})(PageForm);



// WEBPACK FOOTER //
// ./src/components/StreamingsForm/index.jsx